import { useState } from "react"; 
//-------------------------------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Modal from "src/components/common/modal";
import PMNumbers from "src/components/common/PMNumbers";
// import holidays from "src/components/main/outsideHolidays";
import {
    isMobilePhone, 
    getDatefromWeekNum, 
    myAxios, 
    MyFormData, 
    calcEmergencyLocate, 
    LMStatusOpts, 
    arrayReducer, 
    getDateEndFromWeekNum, 
    getTimeStamp, 
} from "src/components/common/functions";
//-------------------------------------------------------------------------------------------------------------------
export default function LocatorEmergencyForm({
    closeIt, 
    defaultData, 
    week, 
    dayIndex, 
    admin, 
    email, 
    userName, 
    lanId, 
}){
    const weekTitle = getDateEndFromWeekNum(week);
    //-------------------------------------------------------------------------------------------------------------------
    const modalWidth = "80%";
    //-------------------------------------------------------------------------------------------------------------------
    const weekData = defaultData.emergency;
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [dayData, setData] = useState(defaultData.emergency[dayIndex]);
    //-------------------------------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const forms = useMyStore((state) => state.outsideserviceLocatorForms);
    const setForms = useMyStore((state) => state.setOutsideserviceLocatorForms);
    const curForms = forms[week] ?? [];
//-------------------------------------------------------------------------------------------------------------------
    const handleSaveClose = async() => {
        const formData = new MyFormData();
        formData.append("wk", week);
        formData.append("index", dayIndex);
        formData.append("dayData", JSON.stringify(dayData));
        if(admin){
            formData.append("userEmail", email);
        }
        //------------------------------------
        setShowLoader(true);
        const res = await myAxios("outside/locator/emergency/save.php", formData);
        setShowLoader(false);
        if(!res) return;
        //------------------------------------
        if(admin){
            setForms(week, curForms.map(allForms => allForms.email === email?
                {...allForms, 
                    [week]:{
                        emergency: 
                        [
                            ...weekData.slice(0, dayIndex), 
                            {
                                ...dayData, 
                                status: "Saved", 
                                saveTime: getTimeStamp(), 
                            }, 
                            ...weekData.slice(dayIndex + 1)
                        ], week
                    }
                }:allForms)
            );
        }else{
            setForms(week, curForms.map(form => form.week === week?{
                ...form, 
                emergency: [
                    ...weekData.slice(0, dayIndex), 
                    {
                        ...dayData, 
                        status: "Saved", 
                        saveTime: getTimeStamp()
                    }, 
                    ...weekData.slice(dayIndex + 1)
                ], week
            }:form));
        }
        closeIt();
        //----------------------------------------------------------------
    }
    const getFirstNonLunchIndex = () => {
        const jobs = dayData.data;
        for(let i = 0; i < jobs.length; i++){
            if(jobs[i].category !== "lunch"){
                return i;
            }
        }
        return false;
    }
    const handleSubmit = async() => {
        if(!window.confirm("Are your sure to submit for the day?")){
            return;
        }
        if(getFirstNonLunchIndex() === false){
            window.alert("No job or event to submit.");
            return;
        }
        const rawData = calcEmergencyLocate(dayData);
        const table = [];
        rawData.data.forEach((d, i) => {
            switch(d.category){
                case "job":
                    table.push([
                        i + 1, 
                        d.ticketNumber, 
                        "", 
                        d.start, 
                        d.end, 
                        d.mins, 
                        d.statusGas === "blank"?"":d.statusGas, 
                        d.statusElectric === "blank"?"":d.statusElectric,
                        d.pmNumber,
                        d.comment
                    ]);
                    break;
                case "event":
                    table.push([
                        i + 1, 
                        "", 
                        "", 
                        d.start, 
                        d.end, 
                        d.mins,
                        "",
                        "",
                        d.pmNumber,
                        d.comment
                    ]);
                    break;
                default:
            }
            
        })
        const col1 = [
            [rawData.data[0].start],
            [rawData.data[rawData.data.length - 1].end], 
            [rawData.ot]
        ];
        const currentDivision = divisions.data.find(d => d.division === dayData.division);
        const col3 = [
            [userName || user.userName], 
            [lanId || user.lanId], 
            [getDatefromWeekNum(week, dayIndex)], 
            [currentDivision.division], 
            [currentDivision.supervisorName], 
            [currentDivision.supervisorEmail]
        ];
        const formData = new MyFormData();
        formData.append("weekTitle", weekTitle);
        formData.append("formDate", rawData.date);
        formData.append("table", JSON.stringify(table));
        formData.append("col1", JSON.stringify(col1));
        formData.append("col3", JSON.stringify(col3));
        formData.append("form", "locatorEmergency");

        formData.append("wk", week);
        formData.append("index", dayIndex);
        formData.append("dayData", JSON.stringify(dayData));
        if(admin){
            formData.append("userEmail", email);
        }
        //------------------------------------
        setShowLoader(true);
        const res = await myAxios("outside/locator/emergency/submit.php", formData);
        setShowLoader(false);
        if(!res) return;
        //------------------------------------
        if(admin){
            setForms(week, curForms.map(allForms => allForms.email === email?
                {...allForms, 
                    [week]:{
                        emergency: 
                        [
                            ...weekData.slice(0, dayIndex), 
                            {
                                ...dayData, 
                                status: "Submitted", 
                                submitTime: getTimeStamp(), 
                                id: res.data
                            }, 
                            ...weekData.slice(dayIndex + 1)
                        ], week
                    }
                }:allForms)
            );
        }else{
            setForms(week, curForms.map(form => form.week === week?{
                ...form, 
                emergency: 
                [
                    ...weekData.slice(0, dayIndex), 
                    {
                        ...dayData, 
                        status: "Submitted", 
                        submitTime: getTimeStamp(), 
                        id: res.data
                    }, 
                    ...weekData.slice(dayIndex + 1)
                ], week
            }:form));
        }
        closeIt();
        //----------------------------------------------------------------
    }
    // const allOvernightChange = (e, name) => {
    //     if(e.currentTarget.checked){
    //     setData({
    //         ...dayData, 
    //         [name]: true
    //     });
    //     }else{
    //         setData({
    //             ...dayData, 
    //             [name]: false,
    //             data: dayData.data.map(d => ({...d, shiftOvernight: false}))
    //         });
    //     }
    // }
    const overnightChange = (e, jobNum, name) => {
        setData({...dayData, data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
            {...job, [name]: e.currentTarget.checked}
            :
            {...job, [name]: false}
        )
        });
    }
    const valueChange = (e, jobNum, name) => {
        setData({...dayData, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
            {...job, [name]: e.currentTarget.value}
            :
            job)
        });
    }
    const TimeChange = (e, jobNum, name) => {
        setData({
            ...dayData, 
            data:
            dayData.data.map((job, jobnumber) => jobnumber === jobNum?
                {
                    ...job, 
                    [name]: e.currentTarget.value
                }
                :
                (jobnumber === jobNum + 1?
                {
                    ...job, 
                    start: e.currentTarget.value
                }
                :
                job)
            )
        });
    }
    const objectValueChange = (e, name) => {
        setData({
            ...dayData, 
            [name]: e.currentTarget.value
        });
    }
    const isLastJobOvernight = () => {
        const jobs = dayData.data;
        for(let i = jobs.length - 1; i >= 0; i--){
            if(jobs[i].category === "job"){
                const job = jobs[i];
                if(
                    job.mobInOvernight || 
                    job.mobInLunchOvernight || 
                    job.lunchOvernight || 
                    job.lunchMobOutOvernight || 
                    job.mobOutOvernight
               ){
                    return true;
                }else{
                    return false;
                }
            }
        }
    }
    //-------------------------------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = "Edit Form"
            width = {modalWidth}
            handleFormSubmit = {handleSubmit}
            actionKey = "Submit for the day"
            onSave = {handleSaveClose}
            onSaveTitle = {"Save & Close"}
        >
            <h1 className = "p-3">{admin?`${userName} - `:null}{week?`Emergency ${dayIndex + 1}`:null}</h1>
            <div>
                <div className = "m-2">
                    <span className = "blk">
                        <span className = "mr-3">Date</span>
                        <input
                            type = "date"
                            min = {getDatefromWeekNum(week, 0) || "1900-01-01"}
                            max = {getDatefromWeekNum(week, 6) || "2999-12-31"}
                            required
                            className = "mr-3 form-control"
                            value = {dayData.date || ""}
                            onChange = {e => objectValueChange(e, "date")}
                        />
                    </span>
                    <span className = "blk">
                        <span className = "mr-3">Division</span>
                        <select className = "mr-3 form-control inline" value = {dayData.division} required
                            onChange = {e => {
                                objectValueChange(e, "division");
                            }}
                        >
                            <option value = "">Select</option>
                            {divisions.data.map((d, i) => <option key = {i}>{d.division}</option>)}
                        </select>
                    </span>
                    {/*
                    <span className = "blk">
                        <span className = "mr-3">Overnight job?</span>
                        <input type = "checkbox" className = "mr-3" style = {{width: 30, height: 30, verticalAlign: "middle"}} value = {dayData.overnight}
                            onChange = {e => {
                                allOvernightChange(e, "overnight");
                            }}
                        />
                    </span>
                    */}
                </div>
                <div className = "mb-3">
                        <span className = "btn btn-success m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight(dayIndex)){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [{
                                        category: "job",
                                        start: dayData.mobInEnd
                                    }, ...dayData.data]
                                });
                            }}
                        >
                            Add Ticket to Below
                        </span>
                        <span className = "btn btn-info m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight(dayIndex)){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [{
                                        category: "event",
                                        start: dayData.mobInEnd
                                    }, ...dayData.data]
                                });
                            }}
                        >
                            Add Event to Below
                        </span>
                    </div>
                {dayData.data.map((job, jobNum) => (
                <div className = "border rounded p-2 m-2" key = {jobNum}>
                    {job.category === "job"?
                    <div className = "mb-3">
                        <div className = "m-2">
                            
                            <span className = "blk">
                                <span className = "mr-3">{jobNum + 1}. Ticket Number</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.ticketNumber || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "ticketNumber");}}
                                />
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">Start</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control d-inline w-auto`}`} required 
                                step = "0" type = "time" disabled = {jobNum?true:false}  value = {job.start || ""}
                                onChange = {e => {
                                    //const currentjob = (data.find((day, daynumber) => dayIndex === daynumber).find((job, jobnumber) => jobnumber === jobNum));
                                    TimeChange(e, jobNum, "start");
                                }} 
                                />
                            </span>
                            {dayData.overnight? 
                            <span className = "blk">
                                <input className = "mr-1" type = "checkbox" style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                                    checked = {job.shiftOvernight || false} 
                                    onChange = {e => {overnightChange(e, jobNum, "shiftOvernight");}}
                                />
                                <span className = "mr-3">Overnight</span>
                            </span>
                            :null}
                            <span className = "blk">
                                <span className = "mr-3">End</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control d-inline w-auto`}`} type = "time" value = {job.end || ""} step = "0" required
                                    min = {job.shiftOvernight?"":job.start}
                                    onChange = {e => {
                                        //validate time
                                        //const currentjob = (data.find((day, daynumber) => dayIndex === daynumber).find((job, jobnumber) => jobnumber === jobNum));
                                        TimeChange(e, jobNum, "end");
                                    }} 
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">Status Gas</span>
                                <select
                                    className = "mr-3 form-control inline"
                                    required
                                    value = {job.statusGas || ""}
                                    onChange = {e => {
                                        valueChange(e, jobNum, "statusGas");
                                    }}
                                >
                                    <option value = "">Select</option>
                                    <option>Feild Meet</option>
                                    <option value = "blank">No facilities were marked</option>
                                    {/*---------------------------------*/}
                                    {Object.keys(LMStatusOpts).map((key, keyIndex) => <optgroup key = {keyIndex} label = {key}>
                                        {LMStatusOpts[key].map((value, valueIndex) => <option key = {valueIndex}>{value}</option>)}
                                    </optgroup>)}
                                    {![...Object.values(LMStatusOpts).reduce(arrayReducer, []), "", "Feild Meet", "blank"].includes(job.statusGas)?<option>{job.statusGas}</option>:<></>}
                                </select>
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">Status Electric</span>
                                <select
                                    className = "mr-3 form-control inline"
                                    required
                                    value = {job.statusElectric || ""} 
                                    onChange = {e => {
                                        valueChange(e, jobNum, "statusElectric");
                                    }}
                                >
                                    <option value = "">Select</option>
                                    <option>Feild Meet</option>
                                    <option value = "blank">No facilities were marked</option>
                                    {/*---------------------------------*/}
                                    {Object.keys(LMStatusOpts).map((key, keyIndex) => <optgroup key = {keyIndex} label = {key}>
                                        {LMStatusOpts[key].map((value, valueIndex) => <option key = {valueIndex}>{value}</option>)}
                                    </optgroup>)}
                                    {![...Object.values(LMStatusOpts).reduce(arrayReducer, []), "", "Feild Meet", "blank"].includes(job.statusElectric)?<option>{job.statusElectric}</option>:<></>}
                                </select>
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">PM Number</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.pmNumber || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "pmNumber");}}
                                    pattern = "(?!0{8})[0-9]{8}"
                                    list = "PMNumbers"
                                />
                                <span style = {{color: "red"}}>
                                    {job.pmNumber?.match(/^[0-9]{8}$/)?null:<>* 8 digit number *</>}
                                    {job.pmNumber?.match(/^0{8}$/)?<>* use Event for non-billable instead *</>:null}
                                </span>
                                <datalist id = "PMNumbers">
                                    {PMNumbers[dayData.division]?.map((d, di) => <option key = {di} value = {d.value}>{d.name}</option>)}
                                    <option value = {"43533937"}>FIRE PM</option>
                                </datalist>
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">Location/Comment</span>
                                <textarea className = "mr-3 form-control inline" type = "text" style = {{minWidth: "60vw"}} value = {job.comment || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "comment");}}
                                />
                            </span>
                        </div>
                    </div>
                    :null}
                    {job.category === "event"?
                    <div className = "mb-3">
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">{jobNum + 1}. Event</span>
                                <textarea className = "mr-3 form-control inline" type = "text" style = {{minWidth: "60vw"}} value = {job.comment || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "comment");}}
                                />
                            </span>
                        </div>
                        <div className = "m-2">
                            <span className = "blk">
                                <span className = "mr-3">PM Number</span>
                                <input className = "mr-3 form-control inline" type = "text" value = {job.pmNumber || ""} required
                                    onChange = {e => {valueChange(e, jobNum, "pmNumber");}}
                                    pattern = "[0-9]{8}"
                                    list = "PMNumbers2"
                                /> {job.pmNumber?.match(/^[0-9]{8}$/)?null:<>* 8 digit number *</>}
                                <datalist id = "PMNumbers2">
                                    {PMNumbers[dayData.division]?.map((d, di) => <option key = {di} value = {d.value}>{d.name}</option>)}
                                    <option value = {"43533937"}>FIRE PM</option>
                                    <option value = {"00000000"}>Non-Billable</option>
                                </datalist>
                            </span>
                            <span className = "blk">
                                <span className = "mr-3">Start</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} required
                                    type = "time" disabled = {jobNum?true:false} value = {job.start || ""} 
                                    onChange = {e => {
                                        //validate time
                                        //const currentjob = (data.find((day, daynumber) => dayIndex === daynumber).find((job, jobnumber) => jobnumber === jobNum));
                                        TimeChange(e, jobNum, "start");
                                    }} 
                                />
                            </span>
                            {dayData.overnight?
                            <span className = "blk">
                                <input className = "mr-1" type = "checkbox" style = {{width: 30, height: 30, verticalAlign: "middle"}} 
                                    checked = {job.shiftOvernight || false} 
                                    onChange = {e => {overnightChange(e, jobNum, "shiftOvernight");}}
                                />
                                <span className = "mr-3">Overnight</span>
                            </span>
                            :null}
                            <span className = "blk">
                                <span className = "mr-3">End</span>
                                <input className = {`mr-3 ${isMobilePhone?`w-auto`:`form-control inline`}`} type = "time" value = {job.end || ""} step = "0" required
                                    min = {job.shiftOvernight?"":job.start}
                                    onChange = {e => {
                                        //validate time
                                        //const currentjob = (data.find((day, daynumber) => dayIndex === daynumber).find((job, jobnumber) => jobnumber === jobNum));
                                        TimeChange(e, jobNum, "end");
                                    }} 
                                />
                            </span>
                        </div>
                    </div>
                    :null}
                    <div className = "mb-3">
                        <span className = "btn btn-danger mx-3" onClick = {() => {
                            if(!window.confirm("Are you sure to delete this?")) return;
                            setData({
                                ...dayData,
                                data:
                                dayData.data.map(
                                    (j, jobnumber) => 
                                    jobNum === 0?({...j, start: dayData.mobInEnd}):
                                    jobnumber === (jobNum + 1)?({...j, start: dayData.data[jobnumber - 2].end}):j
                                
                                )
                                .filter((j, jobnumber) => (jobNum !== jobnumber))
                            });
                        }}>
                            Delete This
                        </span>
                        <span className = "btn btn-success m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight(dayIndex)){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({
                                    ...dayData, 
                                    data:
                                    [...dayData.data.slice(0, jobNum + 1), {
                                        category: "job",
                                        start: dayData.data.length?
                                        dayData.data[jobNum].end
                                            :
                                            dayData.mobInEnd
                                    }, ...dayData.data.slice(jobNum + 1)]
                                });
                            }}
                        >
                            Add Ticket to Below
                        </span>
                        <span className = "btn btn-info m-3" 
                            onClick = {() => {
                                if(isLastJobOvernight(dayIndex)){
                                    window.alert("Remove overnight to add new job at this day!");
                                    return;
                                }
                                setData({...dayData, data:
                                    [...dayData.data.slice(0, jobNum + 1), {
                                        category: "event",
                                        start: dayData.data.length?dayData.data[jobNum].end:dayData.mobInEnd
                                    }, ...dayData.data.slice(jobNum + 1)]
                                });
                            }}
                        >
                            Add Event to Below
                        </span>
                    </div>
                </div>
                ))}
            </div>
        </Modal>
    )
}